import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {

    constructor(private toastr: ToastrService) {}

    openSnackBar(message: string, action: string) {
        this.toastr.success(message, '', { timeOut: 3000, positionClass: 'toast-top-right' });
    }

}